<template>
  <div
    class="flex min-h-[4.25rem] w-full flex-row items-center space-x-3 border-l-6 border-primary px-5 py-2"
    :style="{
      borderColor:
        item.product?.color ?? `rgb(${colorPrimary})`,
    }"
  >
    <div class="flex-1">
      <div class="flex-1">
        <div class="line-clamp-1 text-left text-sm">
          {{ item.product?.name }}
        </div>
        <div
          class="line-clamp-1 text-left text-xs text-background-fg/70"
        >
          {{ item.note }}
        </div>
      </div>
      <div class="ml-3 text-xs">
        <div
          v-for="(modifiers, group) in groupedModifiers"
          :key="group"
          class="flex flex-wrap space-x-1"
        >
          <div
            v-for="modifier in modifiers"
            :key="modifier.id"
          >
            {{ modifier.label }}
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col items-end">
      <p class="line-clamp-1 text-sm font-semibold">
        {{ formatToMerchantCurrencyString(item.price) }}
      </p>
      <p
        v-if="item.quantity > 1"
        class="line-clamp-1 text-xs font-semibold"
      >
        x{{ item.quantity }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CurrentOrderOrderItem } from "@/composables/useCurrentOrder"
import type { DeepReadonly } from "vue"
import { useCssVar } from "@vueuse/core"

const { formatToMerchantCurrencyString } = useCurrency()

const props = defineProps<{
  item: DeepReadonly<CurrentOrderOrderItem>
}>()

const colorPrimary = useCssVar("--color-primary")

const groupedModifiers = computed(() =>
  props.item.modifiers
    ? groupBy([...props.item.modifiers], (m) => m.groupId)
    : {}
)
</script>
